/** @format */

import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { ReactComponent as PageBannerSVG } from "../../../Assets/img/big-lkwb.svg";
import { useSelector, useDispatch } from "react-redux";
import HTMLParser from "../../Components/HTMLParser";
import { allProducts } from "../../../Features/HomeApi/HomeSlice";
import { Link } from "react-router-dom";
import SEO from "../../Components/Seo/Seo";
import Loader from "../../Components/Loader/Loader";

const Voculabary = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(allProducts());
  }, [dispatch]);

  const { voculabary, isLoading } = useSelector(
    (state) => state.home?.allProduct || {},
  );

  // Show loader while fetching
  if (isLoading) {
    return (
      <div className="loading__mode bigLoading">
        <Loader />
      </div>
    );
  }

  // Dynamic SEO description
  const seoDescription =
    voculabary && voculabary.length > 0 ?
      `Explore ${voculabary.length} English vocabulary items. Improve your language skills with LWKB's curated words and examples.`
    : "Explore our English vocabulary collection. Improve your language skills with our curated words and examples.";

  return (
    <>
      {/* SEO */}
      <SEO
        title="Vocabulary - LKWB"
        description={seoDescription}
        path="/voculabary"
      />

      {/* Page Banner */}
      <div className="pageBanner">
        <PageBannerSVG />
        <Container>
          <div className="page-wrap">
            <h3>Vocabulary</h3>
          </div>
          <div className="custom-shape-divider-bottom-1678688493">
            <svg
              data-name="Layer 1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 1200 120"
              preserveAspectRatio="none"
            >
              <path
                d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
                className="shape-fill"
              ></path>
            </svg>
          </div>
        </Container>
      </div>

      {/* Vocabulary List */}
      <section className="section">
        {voculabary && voculabary.length > 0 ?
          <Container>
            <Row className="g-4">
              {voculabary.map((item) => (
                <Col
                  key={item.id}
                  className="eachbooknote"
                  lg={4}
                  sm={6}
                  xs={12}
                >
                  <Link to={`/books-notes/booknotessingle/${item.id}`}>
                    <img src={item.image} alt={`Vocabulary: ${item.title}`} />
                  </Link>
                  <h3>
                    <Link to={`/books-notes/booknotessingle/${item.id}`}>
                      {item.title}
                    </Link>
                  </h3>
                  {item.excerpt && (
                    <p>
                      <HTMLParser>{item.excerpt}</HTMLParser>
                    </p>
                  )}
                </Col>
              ))}
            </Row>
          </Container>
        : <Container>
            <div className="dashboard-contents">
              <p>No vocabulary items are available at the moment.</p>
            </div>
          </Container>
        }
      </section>
    </>
  );
};

export default Voculabary;
